var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';

var FormInput = function (_Component) {
    _inherits(FormInput, _Component);

    function FormInput() {
        _classCallCheck(this, FormInput);

        return _possibleConstructorReturn(this, (FormInput.__proto__ || Object.getPrototypeOf(FormInput)).apply(this, arguments));
    }

    _createClass(FormInput, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                name = _props.name,
                onValidityStateUpdate = _props.onValidityStateUpdate;


            if (this.context.form) {
                this.context.form.registerInput(name, onValidityStateUpdate);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.context.form) {
                this.context.form.unregisterInput(this.props.name);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                null,
                this.props.children
            );
        }
    }]);

    return FormInput;
}(Component);

FormInput.propTypes = {
    children: PropTypes.node.isRequired,
    /** callback called when Form pushed down a new validityState, useful for displaying server validation errors */
    onValidityStateUpdate: PropTypes.func.isRequired,
    /** Input name */
    name: PropTypes.string.isRequired
};
FormInput.contextTypes = {
    form: PropTypes.shape({
        registerInput: PropTypes.func.isRequired,
        unregisterInput: PropTypes.func.isRequired
    })
};


export default FormInput;